/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_INVITEE_DATA, INVITEE_DATA_RECEIVED } = constants.GetInviteeConstants;

export default {
    REQUEST_INVITEE_DATA,
    INVITEE_DATA_RECEIVED,

  requestInviteeData: payload => ({
    type: REQUEST_INVITEE_DATA,
    payload
  }),
  inviteeDataReceived: () => ({
    type: INVITEE_DATA_RECEIVED
  }),
};
